import { getAuth, signInWithCustomToken } from "firebase/auth"
import { auth } from "./firebase"
import { applySnapshot } from "mobx-state-tree"
import { Analytics } from "../utils/analytics"
import { roomsUnsubscribe, tripUnsubscribe } from "../components/templates/AuthProvider"
import { remove } from "../utils/storage"
import { deleteUserDeviceToken } from "./firebase-functions/userDeviceTokens"
import { _rootStore } from "../models/helpers/useStores"

export async function firebaseAuthUsingToken(authToken: string) {
  try {
    const authedUser = await signInWithCustomToken(auth, authToken)
    console.log("User authenticated using token", { authedUser })
    return authedUser
  } catch (error) {
    console.error("cannot login", { error })
  }
  return null
}

export const signOut = async () => {
  Analytics.logSignOut()

  tripUnsubscribe?.()
  roomsUnsubscribe?.()

  remove("twilioAccessToken")

  await deleteUserDeviceToken()

  if (getAuth().currentUser) {
    await getAuth().signOut()
  }

  applySnapshot(_rootStore, {
    loggedInUser: undefined,
  })
}
